import { useEffect } from 'react';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import MiddleFeaturesContext from './context/middle-features.context.js';
import { ThemeProvider } from '@fasstech/middle-design-system';
import { getMiddleImageSrc, getMiddleText } from '@fasstech/middle-client';
import PropTypes from 'prop-types';
import getExtraGraphics from '@@app/extra/getExtraGraphics.js';
import getExtraPageTitle from '@@app/extra/getExtraPageTitle.js';
import { usePreviousInBackButton } from './hooks/usePreviousInBackButton.jsx';

const Middle = ({ middleFeatures, children }) => {
  const { favIcon, colors } = getExtraGraphics();
  const pageTitle = getExtraPageTitle(
    getMiddleText(middleFeatures, 'GENERAL_CLIENT_NOM', 'Middle')
  );
  usePreviousInBackButton();

  const changeFavicon = (src) => {
    const link = document.querySelector('link[rel*=\'icon\']') || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = src;
    document.getElementsByTagName('head')[0].appendChild(link);
  };

  useEffect(() => {
    if (!isNilOrEmpty(middleFeatures)) {
      document.title = pageTitle;
      changeFavicon(
        favIcon ||
        getMiddleImageSrc(
          middleFeatures,
          'GENERAL_GRAPHIC_CLIENT_FAVICON',
          { width: '48px' },
          '/images/logo.svg'
        )
      );
    }
  }, [middleFeatures, favIcon, pageTitle]);

  return (
    <>
      {!isNilOrEmpty(middleFeatures) && (
        <ThemeProvider
          theme={{
            colors: {
              primary:
                colors.PRIMARY_COLOR ||
                getMiddleText(middleFeatures, 'GENERAL_GRAPHIC_PRIMARY_COLOR', null, '#00B3DA'),
              secondary:
                colors.SECONDARY_COLOR ||
                getMiddleText(middleFeatures, 'GENERAL_GRAPHIC_SECONDARY_COLOR', null, '#27ABA3'),
              primaryLight:
                colors.PRIMARY_LIGHT_COLOR ||
                getMiddleText(
                  middleFeatures,
                  'GENERAL_GRAPHIC_PRIMARY_LIGHT_COLOR',
                  null,
                  '#DDF6FB'
                ),
              secondaryLight:
                colors.SECONDARY_LIGHT_COLOR ||
                getMiddleText(
                  middleFeatures,
                  'GENERAL_GRAPHIC_SECONDARY_LIGHT_COLOR',
                  null,
                  '#83CDC6'
                ),
              secondaryLighter:
                colors.SECONDARY_LIGHTER_COLOR ||
                getMiddleText(
                  middleFeatures,
                  'GENERAL_GRAPHIC_SECONDARY_LIGHTER_COLOR',
                  null,
                  '#D8EFED'
                ),
              secondaryLightest:
                colors.SECONDARY_LIGHTEST_COLOR ||
                getMiddleText(
                  middleFeatures,
                  'GENERAL_GRAPHIC_SECONDARY_LIGHTEST_COLOR',
                  null,
                  '#27ABA30D'
                ),
              success: getMiddleText(
                middleFeatures,
                'GENERAL_GRAPHIC_SUCCESS_COLOR',
                null,
                '#008450'
              ),
              defaultText: getMiddleText(
                middleFeatures,
                'GENERAL_GRAPHIC_DEFAULT_TEXT_COLOR',
                null,
                '#202326'
              ),
              error: getMiddleText(middleFeatures, 'GENERAL_GRAPHIC_ERROR_COLOR', null, '#E80C0C')
            },
            fonts: {
              main: getMiddleText(
                middleFeatures,
                'GENERAL_GRAPHIC_PRIMARY_TEXT_FONT',
                null,
                'Palanquin'
              ),
              titles: getMiddleText(
                middleFeatures,
                'GENERAL_GRAPHIC_SECONDARY_TEXT_FONT',
                null,
                'Palanquin'
              )
            }
          }}>
          <MiddleFeaturesContext.Provider value={middleFeatures}>
            {children}
          </MiddleFeaturesContext.Provider>
        </ThemeProvider>
      )}
    </>
  );
};

Middle.propTypes = {
  children: PropTypes.node
};

export default Middle;
